/**
 * @module auth
 * @require MA.Config
 */

import $ from 'jquery';

import { handleProSelection } from './common/auth.es6';
import Form from './common/form';
import Ga from './common/ga';
import Navigation from './common/navigation';
import { getThorViewEventProps, thorPushEvent } from './common/thor';
import Wa from './common/wa';

function setSessionStorage() {
    const authForms = document.querySelector('[data-signup-form]');

    authForms.addEventListener('submit', () => {
        if (document.querySelector('[data-signup-form] button[type="submit"]')) {
            window.sessionStorage.setItem('display_welcome_message', 'true');
        }
    });
}

function displayUserPassword() {
    const $userPassword = $('#user_password');
    const $userPasswordEye = $('#user_password_eye');

    $userPasswordEye.on('click', function onUserPasswordEyeClick() {
        $userPassword.attr('type', $userPassword.attr('type') === 'password' ? 'text' : 'password');
    });
}

function scrollToFirstError() {
    const errors = $('[data-field-error]');

    if (errors.length > 0) {
        // firstFieldError.first().scrollIntoView({
        //     behavior: 'smooth',
        // });
        const firstError = errors[0];
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}

/**
 * Set analytics events
 */
export function authAnalytics(category, signinEventLabel, signupEventLabel) {
    const formData = {
        signin: {
            displayed: false,
            changed: false,
            submitted: false,
            eventLabel: signinEventLabel,
        },
        signup: {
            displayed: false,
            changed: false,
            submitted: false,
            eventLabel: signupEventLabel,
        },
    };

    const $authForms = $('[data-auth-form]');

    const $authTabs = $('[data-auth-tab]');
    let formName = 'signup';

    if (
        $('[data-signin-form]')
            .find(':submit')
            .is(':visible')
    ) {
        formName = 'signin';
    }
    formData[formName].displayed = true;

    Ga.send({
        hitType: 'event',
        eventCategory: category,
        eventAction: `${formName}_form:landed`,
        eventLabel: formData[formName].eventLabel,
    });

    $authTabs.on('click', function onAuthTabClick() {
        formName = 'signup';
        if ($(this).data('signin-tab') !== undefined) {
            formName = 'signin';
        }
        if (!formData[formName].displayed) {
            formData[formName].displayed = true;
            Ga.send({
                hitType: 'event',
                eventCategory: category,
                eventAction: `${formName}_form:landed`,
                eventLabel: formData[formName].eventLabel,
            });
        }
    });

    $authForms.on('change', function onAuthFormChange() {
        formName = 'signup';
        if ($(this).data('signin-form') !== undefined) {
            formName = 'signin';
        }
        if (!formData[formName].changed) {
            formData[formName].changed = true;
            Ga.send({
                hitType: 'event',
                eventCategory: category,
                eventAction: `${formName}_form:started`,
                eventLabel: formData[formName].eventLabel,
            });
        }
    });

    $authForms.on('submit', function onAuthFormSubmit(e) {
        let attempted = false;

        const $form = $(this);
        e.preventDefault();

        function submitFormHandler() {
            // In case of form has been already submitted
            if (attempted) {
                return;
            }
            attempted = true;
            $form.off('submit');
            $form.trigger('submit'); // Fire default event
        }

        formName = 'signup';
        if ($(this).data('signin-form') !== undefined) {
            formName = 'signin';
        }

        if (!formData[formName].submitted) {
            formData[formName].submitted = true;

            // TL;TR: value could be "undefined", undefined or a value provided as `gaLabel=...` get param
            // formData[formName].eventLabel comes from signinEventLabel and signupEventLabel function params
            // Params are provided by apps/www/www/frontend/src/js/index.es6.js when invoking this function through .apply()
            // and values are injected from apps/www/www/templates/auth/auth.html file, directly taket from "GET" parameter: gaLabel
            // BUT: value is a real string "undefined" if param is omitted (not the JS value undefined, like void 0)
            // and when the signin/signup form is submitted the value is no longer injected in MA.Context.authAnalytics (request === POST)
            // and finally, value is really undefined at this point...
            const overridenEventLabel = formData[formName].eventLabel;

            const eventFlow = new Promise(resolve => {
                Ga.send({
                    hitType: 'event',
                    eventCategory: 'WWW',
                    eventAction: `${formName}_form:submit_attempt`,
                    eventLabel:
                        overridenEventLabel === 'undefined' || !overridenEventLabel
                            ? `${formName}_form:submit_button`
                            : overridenEventLabel,
                    hitCallback: resolve,
                });
            });

            if (
                formName === 'signup' &&
                $form.find('#user_is_pro').is(':checked') &&
                ['USER_PROFILE.REALTOR', 'USER_PROFILE.REPRESENTATIVE'].includes(
                    $form
                        .find('#user_profile')
                        .find(':selected')
                        .val(),
                )
            ) {
                eventFlow.then(() => {
                    const GAPromise = new Promise(resolve => {
                        Ga.send({
                            hitType: 'event',
                            eventCategory: 'WWW',
                            eventAction: 'go:agency_register:landing',
                            eventLabel: 'pro:signup_form:submit_button',
                            hitCallback: resolve,
                        });
                    });
                    const WAPromise = Wa.push(
                        'go:agency_register:landing',
                        'www:signup_form:submit_attempt',
                    );
                    return Promise.all([GAPromise, WAPromise]);
                });
            }

            // form is submitted as soon as all necessary ga events are sent
            // in case of failure: does not matter, submit the form
            eventFlow.finally(submitFormHandler);

            // If GA not responding correctly, force submitting form
            setTimeout(submitFormHandler, 2000);
        }
        if (!formData[formName].changed) {
            formData[formName].changed = true;
            Ga.send({
                hitType: 'event',
                eventCategory: category,
                eventAction: `${formName}_form:started`,
                eventLabel: formData[formName].eventLabel,
            });
        }
    });
}

export function domReady() {
    const $form = $('form');
    thorPushEvent('page_view', getThorViewEventProps('account', 'account_create_pro'));

    Form.bindAjaxForm(
        $form,
        null,
        true,
        () => thorPushEvent('sign_up', { method: 'regular' }),
        () => thorPushEvent('sign_up_error', { method: 'regular' }),
    );
    Form.scrollToFirstError($form);
    handleProSelection();
    displayUserPassword();
    scrollToFirstError();
    Navigation.handleTabsNavNative(document.querySelector('[data-tabs-nav]'));
}

export default {
    domReady,
    authAnalytics,
    setSessionStorage,
};
